var _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F51A51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.78618,
    height: 15.1825,
    rx: 0.89309,
    transform: "matrix(0.707029 0.707184 -0.707029 0.707184 16.7344 6)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 13.2568L13.2609 11.9937L17.3681 16.1017C17.7168 16.4505 17.7168 17.0161 17.3681 17.3649C17.0194 17.7137 16.4539 17.7137 16.1052 17.3649L11.998 13.2568Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63144 7.89476C6.28271 7.54595 6.28271 6.98042 6.63144 6.6316C6.98018 6.28279 7.54559 6.28279 7.89432 6.6316L12.0051 10.7433L10.7422 12.0064L6.63144 7.89476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/failIcon.6c33edef348eacdacdecd9c39de6351c.svg";
export { ForwardRef as ReactComponent };